import React from 'react';
import { InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-beige/70 bg-warmwhite px-6 py-14 sm:px-10 sm:py-16" data-id="element-89" data-mp="3gezdp53xpt1o">
      <div className="mx-auto flex max-w-6xl flex-col gap-8 sm:flex-row sm:items-end sm:justify-between" data-id="element-90" data-mp="32nuh6bvv5gvk">
        <p className="font-serif text-lg tracking-[0.16em] text-ink-900" data-id="element-91" data-mp="36p6b2tlrso9k">
          COMUNIDAD FRESH
        </p>

        <div className="flex flex-col gap-6 sm:items-end" data-id="element-92" data-mp="3uesbfkdvp9j5">
          <a href="https://instagram.com" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 font-sans text-[0.78rem] font-light tracking-wide text-ink-500 transition-colors duration-500 hover:text-sage-600" data-id="element-93" data-mp="3ud7g3sjqpmk8">
            <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-94" data-mp="3qfjgic73r5m0" />
            Instagram
          </a>
          <p className="font-sans text-[0.7rem] font-light tracking-[0.14em] text-ink-400" data-id="element-95" data-mp="2a19qzer4jatl">
            © {new Date().getFullYear()} Comunidad Fresh
          </p>
        </div>
      </div>
    </footer>;
}